import React from "react";
import { Plus } from "lucide-react";
import TaskCard from "./TaskCard";
import { COLUMNS } from "./constants";

export default function KanbanBoard({ tasks, onOpen, onDrop, onAdd, showProject = false, hideIssueChip = false }) {
  const grouped = React.useMemo(() => {
    const g = Object.fromEntries(COLUMNS.map(c => [c.id, []]));
    tasks.forEach(t => {
      let key = t.status || "todo";
      // Legacy mapping
      if (key === "doing") key = "in_progress";
      if (key === "done")  key = "completed";
      if (!g[key]) g[key] = [];
      g[key].push(t);
    });
    return g;
  }, [tasks]);

  const dragStart = (e, id) => e.dataTransfer.setData("text/plain", id);
  const dropOn = (e, colId) => {
    e.preventDefault();
    const id = e.dataTransfer.getData("text/plain");
    if (id) onDrop?.(id, colId);
  };

  return (
    <div className="w-full h-full overflow-x-auto overflow-y-hidden bg-slate-50 p-4" data-testid="tp-kanban">
      <div className="grid gap-3 h-full" style={{ gridTemplateColumns: `repeat(${COLUMNS.length}, minmax(210px, 1fr))` }}>
        {COLUMNS.map(col => (
          <div
            key={col.id}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => dropOn(e, col.id)}
            className="flex flex-col rounded-md overflow-hidden bg-white shadow-sm border border-slate-200"
            data-testid={`tp-col-${col.id}`}
          >
            <div
              className="px-3 py-2 text-white flex items-center justify-between font-semibold"
              style={{ background: col.color }}
            >
              <span className="text-sm tracking-wide">{col.label}</span>
              <span className="text-[11px] bg-black/25 rounded-full w-6 h-6 flex items-center justify-center">
                {grouped[col.id]?.length || 0}
              </span>
            </div>
            <div className="flex-1 overflow-y-auto p-2 space-y-2">
              <button
                onClick={() => onAdd?.(col.id)}
                data-testid={`tp-add-${col.id}`}
                className="w-full text-left text-xs font-bold rounded-md py-2 px-2 flex items-center gap-1 border border-dashed transition"
                style={{ color: col.color, borderColor: `${col.color}66`, background: `${col.color}0d` }}
                onMouseEnter={(e) => { e.currentTarget.style.background = `${col.color}22`; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = `${col.color}0d`; }}
              >
                <Plus size={12} /> Add Task
              </button>
              {(grouped[col.id] || []).map(t => (
                <TaskCard key={t.id} task={t} onOpen={onOpen} onDragStart={dragStart} columnColor={col.color} showProject={showProject} hideIssueChip={hideIssueChip} />
              ))}
              {(grouped[col.id] || []).length === 0 && (
                <div className="text-[10px] text-slate-300 text-center py-4">Drop here</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
